"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aggregationIntervalHelperByValueTypeId = void 0;
const _aggregation_helpers_1 = require("../../_aggregation_helpers");
exports.aggregationIntervalHelperByValueTypeId = {
    cropDegreeDaysCumulativeSinceBiofix_3: _aggregation_helpers_1.dailyOnlyAggregationIntervalHelper,
    cropDegreeDaysCumulativeSinceBiofix_5: _aggregation_helpers_1.dailyOnlyAggregationIntervalHelper,
    cropDegreeDaysCumulativeSinceBiofix_11: _aggregation_helpers_1.dailyOnlyAggregationIntervalHelper,
    cropDegreeDaysCumulativeSinceBiofix_12: _aggregation_helpers_1.dailyOnlyAggregationIntervalHelper,
};
//# sourceMappingURL=degree_days_crop.js.map